import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnInstanceExperimentsUrl } from './paths';
import type { AbnExperimentsType, AbnInstanceExperimentsResponse } from './types';

export async function getAbnInstanceExperiments(instanceName: string, type: AbnExperimentsType = 'all') {
  const response = await api.executeGetRequest<ObjectResponse<AbnInstanceExperimentsResponse>>(
    abnInstanceExperimentsUrl(instanceName),
    { type }
  );

  return response.data;
}
